export enum InstitutionType {
    SCHOOL = 0,
    UNIVERSITY = 1,
}

export interface InstitutionResource {
    id: number;
    name: string;
    institution_type: InstitutionType;
}

export interface UniversityResource extends InstitutionResource {
    has_specific_programs?: boolean;
    has_usm?: boolean;
}
